module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bFPOJ"))).then(() => parcelRequire('iDabs'));